<template>
  <div class="widget-area"> 
    <div class="widget widget_grin_posts_thumb">
      <h3 class="widget-title">{{ $t('sidebar_recent_posts') }}</h3>

      <div class="item">
        <h4 class="title usmall">
          <router-link to="/difference-in-on-lays">{{ $t('sidebar_inonlays_title') }}</router-link>
        </h4>
      </div>

      <div class="item">
        <h4 class="title usmall">
          <router-link to="/in-on-lays-care">{{ $t('sidebar_inonlays_title_one') }}</router-link>
        </h4>
      </div>

      <div class="item">
        <h4 class="title usmall">
          <router-link to="/inlays-hurts">{{ $t('sidebar_inonlays_title_two') }}</router-link>
        </h4>
      </div>
    </div>

    <div class="widget widget_grin_posts_thumb">
      <h3 class="widget-title">{{ $t('sidebar_popular_posts') }}</h3>

      <div class="item">
        <h4 class="title usmall">
          <router-link to="/inlays-logevity">{{ $t('sidebar_inonlays_title_three') }}</router-link>
        </h4>
      </div>

      <div class="item">
        <h4 class="title usmall">
          <router-link to="/inlay-benefits">{{ $t('sidebar_inonlays_title_four') }}</router-link>
        </h4>
      </div>

      <div class="item">
        <h4 class="title usmall">
          <router-link to="/onlay-benefits">{{ $t('sidebar_inonlays_title_five') }}</router-link>
        </h4>
      </div>
      <div class="item">
        <h4 class="title usmall">
          <router-link to="/when-to-avoid-inlays">{{ $t('sidebar_inonlays_title_six') }}</router-link>
        </h4>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlogSidebarAllonX'
}
</script>

